// A failure, said quietly in its section (APS-412, admin-d.md "Errors"): one line with the
// crash glyph, what went wrong in words the reader can act on, anything the app adds under it
// (the server's refusal, a way to sign in again) and, when trying again can help, a ghost
// "Try again". Never a page-wide box. The app words the message (from its API error) and the
// retry label, so the component holds no copy of its own.
import type { ReactNode } from 'react'

export function ErrorState({
  message,
  detail,
  retry,
  retryLabel,
}: {
  message: ReactNode
  /** Under the line: the server's own words, a link to sign in again. */
  detail?: ReactNode
  /** Shown only with retryLabel; leave it out when trying again cannot help (403, 404). */
  retry?: (() => void) | undefined
  retryLabel?: string
}) {
  return (
    <div role="alert" className="err-state">
      <p>
        <span className="g" aria-hidden="true">
          ×{' '}
        </span>
        {message}
      </p>
      {detail}
      {retry && retryLabel ? (
        <button type="button" className="btn ghost sm" onClick={retry}>
          {retryLabel}
        </button>
      ) : null}
    </div>
  )
}
